document.addEventListener("DOMContentLoaded", () => {

    const categories = {
        "Creature Canvas": 111,
        "Anime": 11,
        "Flowers": 63,
        "Religious": 24,
        "The Archive": 28,
        "Wings & Wonder": 70
    };

    const prefix = {
        "Creature Canvas": "C",
        "Anime": "A",
        "Flowers": "F",
        "Religious": "R",
        "The Archive": "T",
        "Wings & Wonder": "W"
    };

    const extension = {
        "Creature Canvas": "png",
        "Anime": "png",
        "Flowers": "png",
        "Religious": "jpg",
        "The Archive": "png",
        "Wings & Wonder": "png"
    };

    const designGrid = document.getElementById("designGrid");

    // Store selected design
    window.selectedDesign = "";
    let currentCategory = "Creature Canvas";

    function loadCategory(category) {
        currentCategory = category;

        designGrid.innerHTML = "";

        const total = categories[category];
        const letter = prefix[category];
        const ext = extension[category];

        for (let i = 1; i <= total; i++) {

            const card = document.createElement("div");
            card.className = "design-card";
            card.dataset.design = `${letter}_${i}`;

            card.innerHTML = `
                <div class="design-check">✓</div>

                <img
                    src="https://cdn.shopify.com/s/files/1/0719/1019/5378/files/${letter}_${i}.${ext}"
                    loading="lazy"
                    alt="${letter}_${i}">

                <h4>${letter}_${i}</h4>
            `;

            // Select Design
            card.addEventListener("click", function () {

                document.querySelectorAll(".design-card").forEach(c => {
                    c.classList.remove("active");
                });

                this.classList.add("active");

                window.selectedDesign = this.dataset.design;
                updateSummary();
                if(window.innerWidth <= 768){
                    mobileNextBar.style.display = "flex";
                    mobileStepText.textContent = "✓ Design Selected";
                }
            });

            designGrid.appendChild(card);

        }

        // Auto-select first design
        const firstCard = designGrid.querySelector(".design-card");

        if (firstCard) {
            firstCard.classList.add("active");
            window.selectedDesign = firstCard.dataset.design;
            updateSummary();
        }

    }

    // Default Category
    loadCategory("Creature Canvas");

    // Category Click
    document.querySelectorAll(".category").forEach(btn => {

        btn.addEventListener("click", function () {

            document.querySelectorAll(".category").forEach(b => {
                b.classList.remove("active");
            });

            this.classList.add("active");

            loadCategory(this.dataset.category);
            updateSummary();

        });

    });
    const searchInput = document.getElementById("designSearch");

    searchInput.addEventListener("input", function () {

        const keyword = this.value.toLowerCase().trim();

        document.querySelectorAll(".design-card").forEach(card => {

            const design = card.dataset.design.toLowerCase();

            if (design.includes(keyword)) {
                card.style.display = "";
            } else {
                card.style.display = "none";
            }

        });

    });
    window.selectedColor = "Noir Black";

    document.querySelectorAll(".color-option").forEach(option => {

        option.addEventListener("click", function(){

            document.querySelectorAll(".color-option").forEach(c=>{
                c.classList.remove("active");
            });

            this.classList.add("active");

            window.selectedColor = this.dataset.color;
            updateSummary();

        });

    });
    window.selectedSize = "M";

    document.querySelectorAll(".size-option").forEach(button => {

        button.addEventListener("click", function(){

            document.querySelectorAll(".size-option").forEach(btn=>{
                btn.classList.remove("active");
            });

            this.classList.add("active");

            window.selectedSize = this.dataset.size;
            updateSummary();

        });

    });
    window.selectedQuantity = 1;

    const qtyValue = document.getElementById("qtyValue");

    document.getElementById("qtyPlus").addEventListener("click", () => {
    window.selectedQuantity++;
    qtyValue.textContent = window.selectedQuantity;
    updateSummary();
    });

    document.getElementById("qtyMinus").addEventListener("click", () => {
    if (window.selectedQuantity > 1) {
        window.selectedQuantity--;
        qtyValue.textContent = window.selectedQuantity;
        updateSummary();
    }
});
    function updateSummary() {

        const design = document.getElementById("summaryDesign");
        const color = document.getElementById("summaryColor");
        const size = document.getElementById("summarySize");
        const qty = document.getElementById("summaryQty");

        if (design) {
            design.textContent = window.selectedDesign || "C_1";
        }

        if (color) {
            color.textContent = window.selectedColor || "Noir Black";
        }

        if (size) {
            size.textContent = window.selectedSize || "M";
        }

        if (qty) {
            qty.textContent = window.selectedQuantity || 1;
        }

    }

    updateSummary();
    // ===============================
// WhatsApp Popup
// ===============================

const whatsappBtn = document.getElementById("whatsappOrder");

const popup = document.getElementById("whatsappPopup");

const popupContinue = document.getElementById("popupContinue");

const popupCancel = document.getElementById("popupCancel");

let whatsappURL = "";

whatsappBtn.addEventListener("click", function(e){

    e.preventDefault();

    const name = document.getElementById("customerName").value.trim();

    const phone = document.getElementById("customerPhone").value.trim();

    const note = document.getElementById("customerNote").value.trim();

    if(name===""){

        alert("Please enter your name.");

        return;

    }

    if(phone===""){

        alert("Please enter your phone number.");

        return;

    }

    document.getElementById("popupDesign").textContent = window.selectedDesign;

    document.getElementById("popupColor").textContent = window.selectedColor;

    document.getElementById("popupSize").textContent = window.selectedSize;

    document.getElementById("popupQty").textContent = window.selectedQuantity;

    const message =
`Hello EMVIK,

I would like to customize a T-shirt.

Design : ${window.selectedDesign}

Color : ${window.selectedColor}

Size : ${window.selectedSize}

Quantity : ${window.selectedQuantity}

Name : ${name}

Phone : ${phone}

Special Instructions :
${note || "None"}

Thank you.`;

    const whatsappNumber = "919112828340"; // Replace with your number

    whatsappURL =
`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    popup.classList.add("show");

});

popupCancel.addEventListener("click", function(){

    popup.classList.remove("show");

});

popupContinue.addEventListener("click", function(){

    window.open(whatsappURL,"_blank");

    popup.classList.remove("show");

});

popup.addEventListener("click", function(e){

    if(e.target===popup){

        popup.classList.remove("show");

    }

});
const resetBtn = document.getElementById("resetCustomizer");
const resetPopup = document.getElementById("resetPopup");
const resetCancel = document.getElementById("resetCancel");
const resetConfirm = document.getElementById("resetConfirm");

resetBtn.addEventListener("click", () => {
    resetPopup.classList.add("show");
});

resetCancel.addEventListener("click", () => {
    resetPopup.classList.remove("show");
});

resetPopup.addEventListener("click", (e) => {
    if (e.target === resetPopup) {
        resetPopup.classList.remove("show");
    }
});

resetConfirm.addEventListener("click", () => {

    // Reset Design
    const firstCard = document.querySelector(".design-card");
    document.querySelectorAll(".design-card").forEach(card => {
        card.classList.remove("active");
    });

    if (firstCard) {
        firstCard.classList.add("active");
        window.selectedDesign = firstCard.dataset.design;
    }

    // Reset Color
    document.querySelectorAll(".color-option").forEach(option => {
        option.classList.remove("active");
    });

    const defaultColor = document.querySelector('.color-option[data-color="Noir Black"]');

    if (defaultColor) {
        defaultColor.classList.add("active");
    }

    window.selectedColor = "Noir Black";

    // Reset Size
    document.querySelectorAll(".size-option").forEach(btn => {
        btn.classList.remove("active");
    });

    const defaultSize = document.querySelector('.size-option[data-size="M"]');

    if (defaultSize) {
        defaultSize.classList.add("active");
    }

    window.selectedSize = "M";

    // Reset Quantity
    window.selectedQuantity = 1;
    document.getElementById("qtyValue").textContent = 1;

    // Clear Customer Details
    document.getElementById("customerName").value = "";
    document.getElementById("customerPhone").value = "";
    document.getElementById("customerNote").value = "";

    // Update Summary
    updateSummary();

    // Close Popup
    resetPopup.classList.remove("show");
});
/* ===========================
   MOBILE STEP FLOW
=========================== */

const mobileNextBar = document.getElementById("mobileNextBar");
const mobileNextBtn = document.getElementById("mobileNextBtn");
const mobileStepText = document.getElementById("mobileStepText");

let currentStep = 0;

function goToSection(id){

    const section = document.getElementById(id);

    if(section){

        section.scrollIntoView({
            behavior:"smooth",
            block:"start"
        });

    }

}

mobileNextBtn.addEventListener("click", function(){

    if(currentStep === 0){

        goToSection("colorSection");

        mobileStepText.textContent = "Choose your colour";

        currentStep = 1;

    }

    else if(currentStep === 1){

        goToSection("sizeSection");

        mobileStepText.textContent = "Choose your size";

        currentStep = 2;

    }

    else if(currentStep === 2){

        goToSection("qtySection");

        mobileStepText.textContent = "Select quantity";

        currentStep = 3;

    }

    else if(currentStep === 3){

        goToSection("customerSection");

        mobileStepText.textContent = "Fill your details";

        currentStep = 4;

    }

});
});